import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import LocationsTable from "../../components/Locations/LocationsTable";





const LocationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Locations" />

       {/* Projects Table */}
        <LocationsTable />

      </MasterLayout>
    </>
  );
};

export default LocationPage;
